import Bugsnag from '@bugsnag/js';
import { SecureService } from './secureService';
import { Config, WTF3 } from '../utilities/config';
import { Helpers } from '../utilities/helpers';

const { querystring } = Helpers;
const basePath = Config.services.building_contents;

const secureService = new SecureService();

const httpReq = async (endpoint, params) => {
  const response = await fetch(`${endpoint}${params}`);
  return response.json ? await response.json() : false;
};


/*_______________Building & Home Contents_______________*/

//CREATE Home Content Document
export const createHomeContent = async (params) => {
  try {
    const response = await fetch(basePath.createHomeContents, {
      method: 'POST',
      headers: {
        ...secureService.defaultHeaders,
        Authorization: secureService.generateAuthHeader(),
      },
      body: JSON.stringify(params),
    })

    return await response.json()
  } catch (err) {
    console.error('Building & Contents Service: createHomeContent catch(err): ', err)
  }
};

//UPDATE Home Content Document by ID
export const updateHomeContent = async (params = {}, id) => {
  try {
    const url = basePath.updateHomeContents.replace(':id', id);
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        ...secureService.defaultHeaders,
        Authorization: secureService.generateAuthHeader(),
      },
      body: JSON.stringify(params),
    })

    return await response.json()
  } catch (err) {
    console.error('Building & Contents Service: updateHomeContent catch(err): ', err)
  }
};

//GET Home Content Document by ID
export const getHomeContent = async (id) => {
  try {
    const url = basePath.getHomeContents.replace(':id', id);
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        ...secureService.defaultHeaders,
        Authorization: secureService.generateAuthHeader(),
      },
    })

    return await response.json()
  } catch (err) {
    console.error('Building & Contents Service: getHomeContents catch(err): ', err)
  }
};

//GET All Home Content Documents by User ID
export const getAllHomeContents = async (user_id) => {
    try {
        if (!user_id) return { success: false };
        const url = basePath.getAllHomeContents.replace(':user_id', user_id);
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                ...secureService.defaultHeaders,
                Authorization: secureService.generateAuthHeader(),
            },
        })

        return await response.json()
    } catch (err) {
        console.error('Building & Contents Service: getAllHomeContents catch(err): ', err.message)
        return { 
            success: false, 
            error: {
                message: err.message || 'Something went wrong while fetching home contents'
            }
        };
    }
}

//DELETE Home Content by ID
export const deleteHomeContent = async (id) => {
    try {
        const url = basePath.deleteHomeContents.replace(':id', id);
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                ...secureService.defaultHeaders,
                Authorization: secureService.generateAuthHeader(),
            },
        })

        return await response.json()
    } catch (err) {
        console.error('Building & Contents Service: deleteHomeContent catch(err): ', err)
    }
}

//GET All Home Content Documents with an active Policy by User ID
export const getAllHomeContentsWithPolicy = async (user_id) => {
    try {
        if (!user_id) return { success: false };

        const response = await getAllHomeContents(user_id)

      const { data } = response ?? {}

        const filteredData = data.filter((item) => item?.insured === true && item?.policy_number && item?.cover_start_date)

        const processedResponse = {
            success: true,
            data: filteredData
        }

        return processedResponse
    } catch (err) {
        console.error('Building & Contents Service: getAllHomeContentsWithPolicy catch(err): ', err.message)
        return {
            success: false,
            error: {
                message: err.message || 'Something went wrong while fetching home contents'
            }
        };
    }
}

/*_______________Quote | Excess | Banking Details | Policy_______________*/

//Remove Home Content from Quote

export const removeHomeContentFromQuote = async (params) => {
    try {
        const url = WTF3.QUOTE.REMOVE_HOME_CONTENTS_FROM_QUOTE
        .replace(':userId', params.user_id)
        .replace(':objectNo', params.objectNo);
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                ...secureService.defaultHeaders,
                Authorization: secureService.generateAuthHeader(),
            },
            body: JSON.stringify(params),
        })

        return await response.json()
    } catch (err) {
        console.error('Building & Contents Service: removeHomeContentFromQuote catch(err): ', err)
    }
}

//POST Home Contents Premium
export const getHomeContentPremium = async function (params = {}, user_id) {
  try {
    const url = WTF3.QUOTE.UPSERT_BUILDING_CONTENTS.replace(':user_id', user_id);
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        ...secureService.defaultHeaders,
        Authorization: secureService.generateAuthHeader(),
      },
      body: JSON.stringify(params),
    })
    return await response.json()
  } catch (err) {
    console.error('Building & Contents Service: getHomeContentPremium catch(err): ', err)
  }
};

// update v2_user document
export const updateUser = async (userId, params) => {
  try {
    const response = await fetch(
      Config.services.user.updateUser.replace(':user_id', userId),
      {
        method: 'PUT',
        headers: {
          ...secureService.defaultHeaders,
          Authorization: secureService.generateAuthHeader(),
        },
        body: JSON.stringify(params),
      }
    )

    return response.json()
  } catch (err) {
    console.error('Building & Contents Service: updateUser catch(err): ', err)
  }
}

//GET Home Contents Excess Data
export const getExcessData = async function (user_id, type) {
  try {
    if (!user_id) {
      throw new Error('Please provide a valid user_id')
    }
    if (!type) {
      throw new Error('Please provide a valid product type')
    }
    const url = `${WTF3.LOOKUP.BUILDING_CONTENTS_EXCESSES}?user_id=${user_id}&type=${type}`
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        ...secureService.defaultHeaders,
        Authorization: secureService.generateAuthHeader(),
      },
    })
    return await response.json()
  } catch (err) {
    console.error('Building & Contents Service: getHomeContentPremium catch(err): ', err)
  }
};

//POST Payment Details
export const saveBankingDetails = async (userId, params) => {
  try {
    const response = await fetch(
      Config.services.building_contents.saveBankingDetails.replace(':user_id', userId),
      {
        method: 'POST',
        headers: {
          ...secureService.defaultHeaders,
          Authorization: secureService.generateAuthHeader(),
        },
        body: JSON.stringify(params),
      }
    )

    return response.json()
  } catch (err) {
    console.error('Building & Contents Service: saveBankingDetails catch(err): ', err)
  }
}

//POST Buy Policy
export const buyPolicy = async (userId, params) => {
  try {
    const response = await fetch(
      Config.services.building_contents.buyPolicy.replace(':user_id', userId),
      {
        method: 'POST',
        headers: {
          ...secureService.defaultHeaders,
          Authorization: secureService.generateAuthHeader(),
        },
        body: JSON.stringify(params),
      }
    )

    return response.json()
  } catch (err) {
    console.error('Building & Contents Service: buyPolicy catch(err): ', err)
  }
}


/*_______________User & Client_______________*/

//GET IWYZE Client
export const getClient = async function (user_id) {
  try {
    const url = basePath.person.getClient.replace(':user_id', user_id);
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        ...secureService.defaultHeaders,
        Authorization: secureService.generateAuthHeader(),
      },
    })
    return await response.json()
  } catch (err) {
    console.error('Building & Contents Service: getClient catch(err): ', err)
  }
};


//UPSERT IWYZE Client
export const upsertClient = async function (params = {}) {
  try {
    const url = basePath.person.upsertClient;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        ...secureService.defaultHeaders,
        Authorization: secureService.generateAuthHeader(),
      },
      body: JSON.stringify(params),
    })
    return await response.json()
  } catch (err) {
    console.error('Building & Contents Service: upsertClient catch(err): ', err)
  }
};

/*_______________Claims_______________*/

//POST a new Home Contents Claim
export const createHomeContentsClaim = async (userId, params) => {
  try {
    const response = await fetch(
      Config.services.building_contents.claims.createHomeContentsClaim.replace(':user_id', userId),
      {
        method: 'POST',
        headers: {
          ...secureService.defaultHeaders,
          Authorization: secureService.generateAuthHeader(),
        },
        body: JSON.stringify(params),
      }
    )

    return response.json()
  } catch (err) {
    console.error('Building & Contents Service: createHomeContentsClaim catch(err): ', err)
  }
}
